import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { router } from "./router";
import { initSentry } from "./lib/sentry";
import "./styles.css";

const queryClient = new QueryClient();

async function bootstrap() {
  // Boot Sentry without blocking the first render so auth and routing stay responsive even when flag providers are slow.
  initSentry();

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

void bootstrap();
